export default class SessionStorage {
  constructor(storageName = '_token') {
    this.cache = {};
    this.storageName = storageName;
  }

  async getItem(key) {
    if (this.cache[key]) {
      return this.cache[key];
    }

    const value = window.localStorage.getItem(key);

    if (!value) {
      throw new Error(`Failed to obtain ${key}`);
    }

    this.cache[key] = value;

    return value;
  }

  async removeItem(key) {
    const data = this.getCookie();

    if (!data[key]) {
      return;
    }

    delete this.cache[key];

    window.localStorage.removeItem(key);
  }

  async setItem(key, value) {
    delete this.cache[key];

    window.localStorage.setItem(key, value);
  }
}
